import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { isAxiosError } from 'axios';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { useErrorToast } from '@/core/errors/useErrorToast';
import { financialPoliciesService } from '../api/financial-policies.service';

export function useFinancialPolicies(enabled: boolean) {
  const client = useQueryClient();
  const onError = useErrorToast();
  const query = useQuery({ queryKey: queryKeys.financialPolicies, queryFn: financialPoliciesService.get, enabled });
  const save = useMutation({ mutationFn: financialPoliciesService.save,
    onSuccess: data => { client.setQueryData(queryKeys.financialPolicies, data); client.setQueryData(queryKeys.affiliateProgram, { enabled: data.affiliatesEnabled ?? false }); toast.success('Políticas financeiras salvas. Nenhuma cobrança foi gerada.'); },
    onError: error => { onError(error, isAxiosError(error) && error.response?.status === 409
      ? 'As políticas foram alteradas por outra pessoa. Recarregue e revise antes de salvar novamente.' : undefined); },
  });
  return { query, save };
}
